import SearchField from "../SearchField/SearchField";
import useUSQS from "../../hooks/useUSQS";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import "./QSUSA.css";
import USQSFormGroup from "./USQSFormGroup";

const QSUSAPackaging = ({ clearfield }) => {
  // Load context values
  const { USQS, setUSQS, setUSQSData } = useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, undoListUSQS } = useUSQSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      USQSEdits,
      editIDUSQS,
      setEditIDUSQS,
      setUSQS,
      setUSQSData,
      addEdits,
      undoListUSQS,
      origin,
      destination
    );
  };
  return (
    <fieldset>
      <legend>Packaging:</legend>
      {USQS.qstype !== 2 ? (
        <>
          <div className='form-group'>
            <label>BagSize:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getbagsizes'
              value={USQS.bagSize || ""}
              valueName='bagSize'
              valueID='bagSizeID'
              customplaceholder='bagSize'
              onItemSelect={(item) => {
                localHandleInputSelect(item, "bagSize", "bagSize");
              }}
              clearfield={clearfield}
            />
          </div>
          <div className='form-group'>
            <label>Marks:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getbagmarktypes'
              value={USQS.bagMarkType || ""}
              valueName='bagMarkType'
              valueID='bagMarkTypeID'
              customplaceholder='bagMarks...'
              onItemSelect={(item) => {
                localHandleInputSelect(item, "bagMarkType", "bagMarkType");
              }}
              clearfield={clearfield}
            />
          </div>
        </>
      ) : (
        <>
          <USQSFormGroup
            readOnly={USQS.qstype === 2}
            labelname={"Bag Size:"}
            inputname={"bagSize"}
            inputtype={"text"}
          />
          <USQSFormGroup
            readOnly={USQS.qstype === 2}
            labelname={"Marks:"}
            inputname={"bagMarkType"}
            inputtype={"text"}
          />
        </>
      )}
    </fieldset>
  );
};

export default QSUSAPackaging;
